// import styled from 'styled-components';
// import login_background from '../../img/cms-sign-in.jpg';
// import send_icon from '../../img/send.png';

// const LoginWrapper = styled.div`

//   .g-sign-in-wrapper {
//     display: flex;
//     background-image: url(${login_background});
//     background-size: cover;
//     background-repeat: no-repeat;
//     width: 100%;
//     height: 100vh;

//     .left-half, .right-half {
//       width: 50%;
//     }
//     .left-half {
//       padding: 10%;
//       .intro-text {
//         h3 {
//           font-size: 48px;
//           margin: 0;
//         }
//         h3:nth-child(1) {
//           color: #2c8ebf;
//         }
//         h3:nth-child(2) {
//           color: #4acdd1;
//         }
//         p {
//           font-size: 24px;
//           color: #fff;
//           margin: 0;
//           span {
//             font-size: 32px;
//           }
//         }
//       }
//     }

//     .right-half {
//       display: flex;
//       justify-content: center;
//       align-self: flex-end;
//       padding: 10% 0;

//       .hidden-login-btn {
//         position: absolute;
//         width: 222px;
//         height: 42px;
//         opacity: 0;
//       }

//       #customBtn {
//         position: relative;
//         display: flex;
//         justify-content: space-between;
//         align-items: center;
//         background: transparent;
//         color: #fff;
//         border: 1px solid #fff;
//         width: 222px;
//         height: 42px;
//         border-radius: 25px;
//         white-space: nowrap;
//         padding: 0 20px 0 0px;

//         .icon {
//           display: flex;
//           position: absolute;
//           top: -1px;
//           left: 0;
//           justify-content: center;
//           align-content: center;
//           background-color: #fff;
//           padding: 5px 8px 5px 5px;
//           width: 60px;
//           border-radius: 25px;
//           margin-left: -1px;
//           transition: all .5s ease-out;
//           img {
//             opacity: 1;
//             transition: opacity .5s ease-out;
//             margin-left: 10px;
//           }
//           p {
//             margin: 0 0 0 -44px;
//             opacity: 0;
//             color: #000;
//             pointer-events: none;
//           }
//         }
//         .buttonText {
//           font-size: 14px;
//           font-weight: bold;
//           /* Use the Roboto font that is loaded in the <head> */
//           font-family: 'Roboto', sans-serif;
//           padding: 0 20px 0 80px;
//         }
//         .send-icon {
//           position: absolute;
//           top: 8px;
//           left: 24px;
//           opacity: 0;
//           border: 1px solid #fff;
//           transition: all .5s ease-out;
//           img {
//             width: 20px;
//             height: 20px;
//           }
//         }

//         &:hover {
//           cursor: pointer;
//           .icon {
//             justify-content: space-around;
//             align-items: center;
//             width: 222px;

//             img {
//               opacity: 0;
//               background: url(${send_icon}) 100%/10% no-repeat;
//             }
//             p {
//               margin: 0;
//               opacity: 1;
//               color: #000;
//             }
//           }          
//           .send-icon {
//             opacity: 1;
//             left: 180px;
//             color: #000;
//           }
//         }
//       }
//     }
//   }
// `;

// export default LoginWrapper;
import styled from 'styled-components';
import login_background from '../../img/iw-sign-in.png';

const LoginWrapper = styled.div`
  .ms-sign-in {
    color: white;
    background: transparent;
    border: none;
    box-shadow: none;
    font-size: 24px;
  }
  @keyframes trail {
    0% {
      top: 10px;
      left: 0;
    }
    22.11% {
      top: 7px;
      left: calc(100% - 67px);
    }
    33% {
      top: calc(33.33% + 6px);
      left: calc(100% - 67px);
    }
    55.11% {
      top: calc(33.33% + 6px);
      left: 29px;
    }
    66% {
      top: calc(66.67% + 2px);
      left: 29px;
    }
    88.11% {
      top: calc(66.67% + 2px);
      left: calc(100% - 79px);
    }
    100% {
      top: 100%;
      left: calc(100% - 78px);
    }
  }

  @keyframes highlight_sales {
    0% {
      color: #01579b;
      text-shadow: 1px 0px 20px #01579b;
    }
    10% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    99% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    100% {
      color: #01579b;
      text-shadow: 1px 0px 20px #01579b;
    }
  }

  @keyframes highlight_research {
    0% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    29% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    33% {
      color: #c62828;
      text-shadow: 1px 0px 20px red;
    }
    37% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    100% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
  }

  @keyframes highlight_editing {
    0% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    62% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    66% {
      color: #c6a700;
      text-shadow: 1px 0px 20px #c6a700;
    }
    70% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    100% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
  }

  @keyframes highlight_formatting {
    0% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    95% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
    99% {
      color: #2e7d32;
      text-shadow: 1px 0px 20px #2e7d32;
    }
    100% {
      color: #fff;
      text-shadow: 1px 0px 20px #fff;
    }
  }

  @keyframes spin {
    from { 
      transform: rotate(0deg);
    }
    to {
      transform: rotate(360deg);
    }
  }

  .loader-16 {
    transform: rotateZ(45deg);
    perspective: 1000px;
    border-radius: 50%;
    width: 96px;
    height: 96px;
  }
  .loader-16:before, .loader-16:after {
    content: '';
    display: block;
    position: absolute;
    top: 0;
    left: 0;
    width: inherit;
    height: inherit;
    border-radius: 50%;
    animation: 1s spin2 linear infinite;
  }
  .loader-16:before {
    transform: rotateX(70deg);
  }
  .loader-16:after {
    transform: rotateY(70deg);
    animation-delay: .4s;
  }
  
  @keyframes rotate {
    0% {
      transform: translate(-50%, -50%) rotateZ(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotateZ(360deg);
    }
  }
  @keyframes rotateccw {
    0% {
      transform: translate(-50%, -50%) rotate(0deg);
    }
    100% {
      transform: translate(-50%, -50%) rotate(-360deg);
    }
  }
  @keyframes spin2 {
    0%,
    100% {
      box-shadow: .2em 0px 0 0px #fff;
    }
    12% {
      box-shadow: .2em .2em 0 0 #fff;
    }
    25% {
      box-shadow: 0 .2em 0 0px #fff;
    }
    37% {
      box-shadow: -.2em .2em 0 0 #fff;
    }
    50% {
      box-shadow: -.2em 0 0 0 #fff;
    }
    62% {
      box-shadow: -.2em -.2em 0 0 #fff;
    }
    75% {
      box-shadow: 0px -.2em 0 0 #fff;
    }
    87% {
      box-shadow: .2em -.2em 0 0 #fff;
    }
  }

  .login-container {
    position: relative;
    width: 100vw;
    height: 100vh;
    background-image: url(${login_background});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    .welcome-heading {
      position: absolute;
      width: 100%;
      top: 40px;
      left: 0;
      display: flex;
      align-items: center;
      h1 {
        margin: 0 0 0 10vw;
        color: #fff;
      }
    }
    .login-wrapper {
      width: 100%;
      max-width: 1200px;
      margin: 0 auto;
      display: flex;
      align-items: center;
      width: 100%;
      height: 100%;
      .login-button-wrapper {
        width: 50%;
        margin: 0;
        height: 100%;
        max-height: 550px;
        position: relative;
        display: flex;
        justify-content: center;
        align-items:center;
        .login-img {
          position: absolute;
          width: 360px;
          animation: spin 20s infinite;
          animation-iteration-count: infinite;
          animation-timing-function: linear;
          &:hover {
            animation-play-state: paused;
          }
        }
        .login-button {
          position: absolute;
          font-size: 24px;
          font-family: regular_semibold;
          width: 90px;
          height: 90px;
          border-radius: 50%;
          border: none;
          background: none;
          color: #fff;
          cursor: pointer;
          outline: none;
          transform: scale(1);
          transition: transform 0.3s ease-out;
          &:hover {
            transform: scale(0.9);
          }
        }
      }
      .teams {
        width: calc(50% - 100px);
        margin: 0 50px;
        height: 100%;
        max-height: 500px;
        position: relative;
        .team-headings {
          position: absolute;
          margin: 0;
          z-index: 3;
        }
        .sales {
          top: 0;
          left: 0;
          animation: highlight_sales 7.75s infinite;
          animation-fill-mode: forwards;
          background-image: url(${login_background});
          background-position: 60% 20%;
        }
        .research {
          top: 33.33%;
          right: 0;
          animation: highlight_research 7.75s infinite;
          animation-fill-mode: forwards;
          background-image: url(${login_background});
          background-position: 80% 40%;
        }
        .editing {
          top: calc(66.67% - 5px);
          left: 0;
          animation: highlight_editing 7.75s infinite;
          animation-fill-mode: forwards;
          background-image: url(${login_background});
          background-position: 60% 56.25%;
        }
        .formatting {
          top: 100%;
          right: 0;
          animation: highlight_formatting 7.75s infinite;
          animation-fill-mode: forwards;
          background-image: url(${login_background});
          background-position: 80% 80%;
        }
        .lines {
          content: '';
          position: absolute;
          height: 3px;
          background-color: #fff;
          z-index: 1;
        }
        .first {
          width: calc(100% - 127px);
          top: 13px;
          left: 70px;
        }
        .second {
          width: 33.33%;
          top: 13px;
          left: calc(100% - 57px);
          transform: rotate(90deg);
          transform-origin: top left;
        }
        .third {
          width: calc(100% - 150px);
          left: 35px;
          top: calc(33.33% + 13px);
        }
        .fourth {
          width: 33.33%;
          top: calc(33.33% + 13px);
          left: 38px;
          transform: rotate(90deg);
          transform-origin: top left;
        }
        .fifth {
          width: calc(100% - 155px);
          left: 85px;
          top: calc(66.67% + 8px);
        }
        .sixth {
          width: 33.33%;
          top: calc(66.67% + 8px);
          left: calc(100% - 69px);
          transform: rotate(90deg);
          transform-origin: top left;
        }
        .dot {
          content: '';
          position: absolute;
          width: 15px;
          height: 15px;
          background-color: #fff;
          border-radius: 50%;
          z-index: 2;
          box-shadow: 0 0 20px 3px #fff;
          animation: trail 7.75s infinite;
        }
      }
    }
  }
`;

export default LoginWrapper;


// WEBPACK FOOTER //
// ./src/components/Login/Login.style.js